export default {
    // B
    badRequest: 'The request was invalid or cannot be processed by the server.',

    // F
    fileIsTooLarge: 'File is too large. Please try uploading a smaller file.',
    forbidden: 'You do not have permission to access this resource.',

    // I
    invalidEmail: 'Invalid email address: Please enter a valid email address.',

    // N
    notFound: 'The requested resource was not found on the server.',
    networkError: 'Network Error',
    networkErrorDescription: 'A network issue has occurred. Please check your Internet connection and try again.',

    // O
    oopsSomethingWentWrong: 'Oops, something went wrong. Please try again later.',

    // S
    serverError: 'An internal server error occurred. Please try again later.',
    serviceUnavailable: 'The service is temporarily unavailable. Please try again later.',
    sessionExpired: 'Your session has expired. The page will reload automatically.',
    // somethingWentWrong: 'Something went wrong.',

    // U
    unauthorized: 'You are not authorized to access this resource. Please log in.',

    // Y
    // yourFileIsTooLarge: 'The uploaded file is too large. Please try again with a smaller file.',
    // yourFileTypeIsUnsupported: 'The uploaded file type is unsupported. Please convert it to a supported format and try again.'
};
